import api from "api";

const commands = {
    // Commands
    list:          (slug, params = {}) =>
        api().get(`/establishments/${slug}/commands`, { params }),
    create:        (slug, payload) =>
        api().post(`/establishments/${slug}/commands`, payload),
    get:           (slug, id) =>
        api().get(`/establishments/${slug}/commands/${id}`),
    update:        (slug, id, payload) =>
        api().put(`/establishments/${slug}/commands/${id}`, payload),
    close:         (slug, id, payload = {}) =>
        api().post(`/establishments/${slug}/commands/${id}/close`, payload),
    cancel:        (slug, id, payload = {}) =>
        api().post(`/establishments/${slug}/commands/${id}/cancel`, payload),

    // Items
    addItem:       (slug, commandId, payload) =>
        api().post(`/establishments/${slug}/commands/${commandId}/items`, payload),
    addItemsBatch: (slug, commandId, payload) =>
        api().post(`/establishments/${slug}/commands/${commandId}/items/batch`, payload),
    updateItem:    (slug, commandId, itemId, payload) =>
        api().put(`/establishments/${slug}/commands/${commandId}/items/${itemId}`, payload),
    deleteItem:    (slug, commandId, itemId) =>
        api().delete(`/establishments/${slug}/commands/${commandId}/items/${itemId}`),

};

export default commands;
